<template>
  <div>
    <b-sidebar width="600px" id="scan-qr" shadow
    >

      <div class="qr-scanner-dialog">
        <b-tabs content-class="mt-3" class="qr-scanner-tabs">
          <b-tab title="Camera" active>
            <div class="text-center mb-3">
              <p>{{ $t('qr.scanInstructions') }}</p>
              <div id="reader" class="qr-reader-container"></div>
            </div>
          </b-tab>

          <b-tab title="Upload File">
            <div class="text-center file-upload-tab">
              <p>{{ $t('qr.uploadInstructions') }}</p>
              <b-form-file
                  v-model="qrFile"
                  :state="Boolean(qrFile)"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  accept="image/*"
                  @input="handleFileUpload"
              ></b-form-file>
              <div class="mt-3 text-center" v-if="qrFile">
              <div class="d-flex flex-column align-items-center">
                <b-img :src="previewUrl" fluid alt="Uploaded QR" class="qr-preview mb-3"></b-img>
                <b-button variant="primary" @click="processUploadedQR">
                  Process QR Code
                </b-button>
              </div>
            </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

    </b-sidebar>
  </div>
</template>

<script>
import { Html5QrcodeScanner, Html5Qrcode, Html5QrcodeScanType } from "html5-qrcode";
import {eventBus} from "@/main";

export default {
  name: "QRScannerDialog",
  data() {
    return {
      qrFile: null,
      previewUrl: null,
      html5QrcodeScanner: null
    };
  },
  mounted() {
    this.initQRScanner();

    eventBus.$off('start-scan-qr-info');
    eventBus.$on('start-scan-qr-info', () => {
      this.initQRScanner();
    });
  },
  beforeDestroy() {
    if (this.html5QrcodeScanner) {
      this.html5QrcodeScanner.clear();
    }
    eventBus.$off('start-scan-qr-info');
  },
  methods: {
    initQRScanner() {
      if (this.html5QrcodeScanner) {
        this.html5QrcodeScanner.clear();
      }

      setTimeout(() => {
        // Configure QR scanner settings
        let qrboxFunction = function (viewfinderWidth, viewfinderHeight) {
          let minEdgePercentage = 0.7; // 70%
          let minEdgeSize = Math.min(viewfinderWidth, viewfinderHeight);
          let qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
          return {
            width: qrboxSize,
            height: qrboxSize
          };
        };

        // Create QR scanner instance
        this.html5QrcodeScanner = new Html5QrcodeScanner(
            "reader",
            {
              qrbox: qrboxFunction,
              fps: 10,
              disableFlip: true,
              focusMode: "continuous",
              aspectRatio: 1,
              showTorchButtonIfSupported: true,
              useBarCodeDetectorIfSupported: true,
              showZoomSliderIfSupported: true,
              defaultZoomValueIfSupported: 2,
              rememberLastUsedCamera: true,
              supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA], // Only camera scanning
              verbose: false // Set to false to reduce console logs
            },
            false // verbose set to false
        );

        // Start scanning - render with autostartscan=true
        this.html5QrcodeScanner.render(this.onScanSuccess, null, /* autostart */ true);
      }, 500);
    },

    onScanSuccess(decodedText, decodedResult) {
      // Stop the scanner
      this.html5QrcodeScanner.clear();

      try {
        // Process the scan result
        console.log(`Scan result: ${decodedText}`, decodedResult);

        // Parse the decoded data
        const data = JSON.parse(decodedText);
        console.log("Decoded data from camera:", data);

        // Close the QR scanner sidebar
        this.$root.$emit('bv::hide::sidebar', 'scan-qr');
        // or alternatively using toggle if hide is not available
        this.$root.$emit('bv::toggle::collapse', 'scan-qr');

        // Wait a moment before opening the ship edit form
        setTimeout(() => {
          // Clean the form first
          eventBus.$emit('clean-ecdis');
          
          // Open the ship edit sidebar
          this.$root.$emit('bv::toggle::collapse', 'ship-edit');

          // Populate the form with data from the QR code
          if (data.type === 'info') {
            eventBus.$emit('clean-ship-form')
            eventBus.$emit('populate-ship-form', {
              user_email: this.$store.state.auth.user.email,
              ship_name: data.name,
              ship_imo: data.IMO,
              ship_country: data.country,
              ecdis_brand: data.ECDIS,
              ecdis_os: data.OS,              
              permit_main: data.permit
            });
          }
        }, 300);
      } catch (error) {
        console.error("Error processing QR code:", error);
        this.$bvToast.toast("Invalid QR code format. Please try again.", {
          title: "Error",
          variant: "danger",
          solid: true
        });

        // Restart scanner after error
        this.initQRScanner();
      }
    },

    handleFileUpload() {
      if (this.qrFile) {
        // Create preview URL
        this.previewUrl = URL.createObjectURL(this.qrFile);
      } else {
        this.previewUrl = null;
      }
    },

    processUploadedQR() {
      if (!this.qrFile) return;

      const html5QrCode = new Html5Qrcode("reader");

      html5QrCode.scanFile(this.qrFile, true)
          .then(decodedText => {
            try {
              const data = JSON.parse(decodedText);
              console.log("Decoded data from file:", data);

              // Close the QR scanner sidebar
              this.$root.$emit('bv::toggle::collapse', 'qr-sidebar');

              // Close the QR scanner sidebar first
              this.$root.$emit('bv::hide::sidebar', 'scan-qr');
              // or alternatively using toggle if hide is not available
              this.$root.$emit('bv::toggle::collapse', 'scan-qr');

              // Wait a moment before opening the ship edit form
              setTimeout(() => {
                // Clean the form first
                eventBus.$emit('clean-ecdis');

                // Open the ship edit sidebar
                this.$root.$emit('bv::toggle::collapse', 'ship-edit');

                console.log("qqqq", data)
                console.log("qqqq", data.shipInfo)

                // Populate the form with data from the QR code
                if (data.type === 'info') {
                  eventBus.$emit('clean-ship-form')
                  eventBus.$emit('populate-ship-form', {
                    user_email: this.$store.state.auth.user.email,
                    ship_name: data.name,
                    ship_imo: data.IMO,
                    ship_country: data.country,
                    ecdis_brand: data.ECDIS,
                    ecdis_os: data.OS,
                    permit_main: data.permit
                  });
                }
              }, 300);
            } catch (error) {
              console.error("Error processing QR code:", error);
              this.$bvToast.toast("Invalid QR code format. Please try again.", {
                title: "Error",
                variant: "danger",
                solid: true
              });
            }
          })
          .catch(error => {
            console.error("Error scanning file:", error);
            this.$bvToast.toast("Could not scan QR code from image. Please try another file.", {
              title: "Error",
              variant: "danger",
              solid: true
            });
          });
    }
  }
};
</script>

<style scoped>
.qr-scanner-dialog {
  padding: 20px;
}

.qr-reader-container {
  margin: 0 auto;
  max-width: 400px;
}

.qr-scanner-tabs >>> .tab-content {
  border-top: none;
  padding: 15px;
  border-radius: 0 0 4px 4px;
}

.file-upload-tab {
  padding: 20px 0;
}

.qr-preview {
  max-width: 300px;
  max-height: 300px;
  margin: 0 auto;
  border-radius: 4px;
}

/* For Vue 2 */
.qr-scanner-dialog >>> #html5-qrcode-anchor-scan-type-change {
  display: none !important;
}

.qr-scanner-dialog >>> .html5-qrcode-section-swaplink {
  display: none !important;
}

.qr-scanner-dialog >>> #html5-qrcode-button-camera-permission {
  background-color: var(--primary) !important;
  color: white !important;
  border-color: var(--primary) !important;
  padding: 0.375rem 0.75rem !important;
  font-size: 1rem !important;
  line-height: 1.5 !important;
  border-radius: 0.25rem !important;
  font-weight: 400 !important;
  text-align: center !important;
  vertical-align: middle !important;
  display: inline-block !important;
  cursor: pointer !important;
}

.qr-scanner-dialog >>> #html5-qrcode-button-camera-permission:hover {
  background-color: #0069d9 !important;
  border-color: #0062cc !important;
}

</style>